import React from "react";
import { withGetScreen } from "react-getscreen";
import Pill from "../../../../shared/Pill/Pill";
import Select from "../../../../shared/Select/Select";

const SmartExtractFilterFidelityPlanSelect = props => {
	let values = [
		{
			label: "Test",
			value: "1"
		}
	];
	return props.isMobile() ? <Select options={values} /> : <Pill>Test</Pill>;
};

export default withGetScreen(SmartExtractFilterFidelityPlanSelect, {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
